import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { ProjectDataflowDetailModel } from '../../../services/ProjectService';
import { t } from 'i18next';
import moment from 'moment';
import { Icon } from '@progress/kendo-react-common';

export function StepsComponent({ details }: { details: ProjectDataflowDetailModel[]; }) {
  const renderStatusIcon = (props: any) => {
      const status = props.dataItem.Status;
      let iconName = '';
      let color = '';
  
      switch (status) {
        case 'Valid':
          iconName = 'check';
          color = 'green';
          break;
        case 'Processing':
          iconName = 'k-icon k-font-icon k-i-reload';
          color = 'gray';
          break;
        case 'ValidWithWarnings':
          iconName = 'check';
          color = 'orange';
          break;
        case 'Failed':
          iconName = 'x';
          color = 'red';
          break;
        default:
          iconName = 'question-mark-circle';
          color = 'gray';
          break;
      }
  
      return (
        <td style={{ color, textAlign: 'center' }}>
          <Icon name={iconName} style={{ color, width: '20px', height: '20px' }} />
      </td>
      );
    };
  return (
    <Grid data={[...details].sort((a, b) => new Date(b.StartDate).getTime() - new Date(a.StartDate).getTime())} style={{ height: "300px" }}>
      <GridColumn 
      field="Status" 
      title={t("general.status")}
      cell={(props) => <td>{renderStatusIcon(props)}</td>} />
      <GridColumn field="Type" title="Type" />
      <GridColumn
      field="StartDate"
      title={t("general.start")}
      cell={(props) => <td>{moment(props.dataItem.StartDate).format("YYYY-MM-DD HH:mm:ss")}</td>} />
      <GridColumn
      field="EndDate"
      title={t("general.end")}
      cell={(props) => <td>{props.dataItem.EndDate ? moment(props.dataItem.EndDate).format("YYYY-MM-DD HH:mm:ss") : ""}</td>} />
    </Grid>
  );
}
